import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	TABLET_BP,
	MOBILE_L_BP,
	DESKTOP_SM_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
} from "@website-builder/utilities-index";

export const Container = styled.div`
	color: ${COLOR_TEXT_PRIMARY_B2C};
	padding: 60px 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		padding: 35px 5px;
	}
	@media only screen and (max-width: ${TABLET_BP}px) {
		padding: 35px 30px;
		${(props) => (props.showInTabletAndMobile ? "" : "display: none;")}
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 35px 20px;
	}
`;

export const Header = styled.h2`
	font-family: var(--ff-haffer-xh);
	font-style: normal;
	font-weight: ${FONT_WT_MEDIUM};
	font-size: 28px;
	line-height: 1.36;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	text-align: center;

	@media only screen and (max-width: ${TABLET_BP}px) {
		font-size: 26px;
		line-height: 1;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		font-size: 26px;
		line-height: 1.38;
	}
`;

export const SubHeader = styled.div`
	font-family: var(--ff-haffer-xh);
	font-size: 16px;
	font-weight: ${FONT_WT_LIGHT};
	line-height: 1.69;
	color: ${COLOR_TEXT_PRIMARY_B2C};
	margin-top: 30px;
	max-width: 600px;
	text-align: center;
`;

export const Values = styled.div`
	display: flex;
	margin-top: 10px;
	justify-content: center;
	text-align: center;

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		flex-wrap: wrap;
	}
`;

export const CardContainer = styled.div`
	margin-top: 20px;
	max-width: 350px;
	margin-right: 25px;
	&:last-child {
		margin-right: 0;
	}

	@media only screen and (max-width: ${TABLET_BP}px) {
		max-width: 250px;
	}
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		max-width: unset;
		margin-right: 0;
	}
`;
